var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Top'),_vm._v(" "),_c('div',{staticClass:"maindiv znotice-wrap bg-gray"},[_c('Banner',{attrs:{"is-detail":false}}),_vm._v(" "),_c('div',{staticClass:"notices mt180 bgw htmldiv"},[_c('banner-title'),_vm._v(" "),_c('Detail',{attrs:{"info":_vm.info}})],1),_vm._v(" "),_c('div',{staticClass:"ht30"})],1),_vm._v(" "),_c('Bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeceeb10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cedu/notice/detail.vue
// module id = null
// module chunks = 